import React, { Fragment, useEffect, useState } from 'react';
import Phaser from 'phaser';
import { useAccount, useNetwork } from 'wagmi';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { Button } from '@mui/material';
import { IonPhaser } from '@ion-phaser/react';
import { toast } from 'react-hot-toast';
import { SceneIntro } from './Scenes/SceneIntro';
import { SceneMain } from './Scenes/SceneMain';
import { SceneMainMenu } from './Scenes/SceneMainMenu';
import { SceneScores } from './Scenes/SceneScores';
import { SceneTopScores } from './Scenes/SceneTopScores';
import { SceneTopScoresMenu } from './Scenes/SceneTopScoresMenu';
import { loadingscene } from './Scenes/loadingscene';
import Header from '../../components/header/HeaderOne';
import Footer from '../../components/footer/Footer';
import { getSpaceships } from '../../web3/SFM-SpaceshipUtils';
import { getWeapons } from '../../web3/SFM-WeaponUtils';
import { getShields } from '../../web3/SFM-ShieldUtils';
import { getRepairkits } from '../../web3/SFM-RepairKitUtils';
import PromptLogin from '../PromptLogin';
import '../../assets/css/game.css';
import SingleUserOwnedNFT from '../../components/NFTCards/SingleUserOwnedNFT';
import { NFTSTypes } from '../../data/nftsType';
import Loader from '../../components/Loader/loader';
import { PayFeesScene } from './Scenes/PayFeeScene';
import { PayFeesScene2 } from './Scenes/PayFeeScene2';

const GameConfigurator = () => {
  const state = {
    initialize: true,
    game: {
      width: 500,
      height: 700,
      dom: {
        createContainer: true,
      },
      type: Phaser.AUTO,
      scene: [
        PayFeesScene,
        PayFeesScene2,
        SceneMainMenu,
        SceneScores,
        SceneIntro,
        SceneMain,
        SceneTopScores,
        loadingscene,
        SceneTopScoresMenu,
      ],
      pixelArt: true,
      physics: {
        default: 'arcade',
        arcade: {
          debug: false,
        },
      },
    },
  };
  const [spaceShips, setSpaceShips] = useState();
  const [tabsKey, setTabsKey] = useState(NFTSTypes.weapon);

  const [weaponsNfts, setWeaponsNfts] = useState();
  const [shieldsNfts, setShieldsNfts] = useState();
  const [repairekitNfts, setRepairekitNfts] = useState();
  const [selectSpaceship, setSelectSpaceship] = useState(false);
  const [selectSpaceshipWarMatrial, setSelectSpaceshipWarMatrial] =
    useState(false);
  const [MaxWeapons, setMaxWeapons] = useState(0);
  const [MaxShields, setMaxShields] = useState(0);
  const [spaceshipcheckedtemp, setspaceshipcheckedtemp] = useState(
    JSON.parse(localStorage.getItem('portofolioChosen'))
  );
  const { initialize, game } = state;
  const { isConnected, address } = useAccount();
  const { chain } = useNetwork();
  const [payingScreen, setPayingScreen] = useState(false);
  const [runChangeDiableState, setRunChangeDiableState] = React.useState(true);
  const [disabledAttr, setDisabledAttr] = React.useState(true);

  const getSpaceShips = async () => {
    const allSpaceShips = await getSpaceships();
    const updatedSpaceShips =
      allSpaceShips &&
      allSpaceShips?.map((spaceShip) => {
        return { ...spaceShip, enteryFees: '$25.00' };
      });

    setSpaceShips(updatedSpaceShips);
    checkPoftofolio();
  };
  const getWeaponsNfts = async () => {
    const weaponsNfts = await getWeapons();
    const updatedWeaponsNfts =
      weaponsNfts &&
      weaponsNfts?.map((weapon) => {
        return { ...weapon, isSelected: false };
      });

    setWeaponsNfts(updatedWeaponsNfts);
  };
  const getShieldsNfts = async () => {
    const shieldsNfts = await getShields();
    const updatedShieldsNfts =
      shieldsNfts &&
      shieldsNfts?.map((shield) => {
        return { ...shield, isSelected: false };
      });
    setShieldsNfts(updatedShieldsNfts);
  };
  const getRepairekitNfts = async () => {
    const repairekitNfts = await getRepairkits();
    const updatedRepairekitNfts =
      repairekitNfts &&
      repairekitNfts?.map((repairKit) => {
        return { ...repairKit, isSelected: false };
      });
    setRepairekitNfts(updatedRepairekitNfts);
  };
  //effect to change
  React.useEffect(() => {
    disableJoin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runChangeDiableState]);

  useEffect(() => {
    //setStartGame(false);
    setPayingScreen(false);
    getSpaceShips();
    getWeaponsNfts();
    getShieldsNfts();
    getRepairekitNfts();
  }, [isConnected, address]);

  const payTicket = () => {
    setPayingScreen(true);
  };

  const spaceshipOnClick = (item) => {
    setspaceshipcheckedtemp(item);
    setMaxWeapons(parseInt(item.maxWeapons));
    setMaxShields(parseInt(item.maxShields));
    payTicket();
    setSelectSpaceship(true);
    disableJoin();
  };

  const weaponsOnClick = (selected, id) => {
    let selectedWeapons = weaponsNfts.filter(({ isSelected }) => isSelected);
    let newwepons;
    //add only when user doesn't exceed max limit
    if ((selected && selectedWeapons.length < MaxWeapons) || !selected) {
      newwepons = weaponsNfts.find((r) => r.tokenId.toString() == id);
      const resIndex = weaponsNfts.findIndex((r) => r.tokenId.toString() == id);
      weaponsNfts.splice(resIndex, 1);
      newwepons.isSelected = selected;
      setWeaponsNfts(
        selected ? [newwepons, ...weaponsNfts] : [...weaponsNfts, newwepons]
      );
    } else {
      if (selected && selectedWeapons.length == MaxWeapons) {
        toast.error(` max weapons to this spaceship is ${MaxWeapons}`);
      }
    }
    let audio;
    if (selected && selectedWeapons.length <= MaxWeapons) {
      audio = new Audio('assets/audio/select.mp3');
      audio.play();
      toast.success(` ${newwepons.name} is selected`);
    } else {
      audio = new Audio('assets/audio/Unselect.mp3');
      toast.error(` ${newwepons.name} is unselected`);
    }
    audio.play();
    setRunChangeDiableState(!runChangeDiableState);
  };
  const shieldsOnClick = (selected, id) => {
    let selectedShields = shieldsNfts.filter(({ isSelected }) => isSelected);
    let newshield;
    //add only when user doesn't exceed max limit
    if ((selected && selectedShields.length < MaxShields) || !selected) {
      newshield = shieldsNfts.find((r) => r.tokenId.toString() == id);
      const resIndex = shieldsNfts.findIndex((r) => r.tokenId.toString() == id);
      shieldsNfts.splice(resIndex, 1);
      newshield.isSelected = selected;
      setShieldsNfts(
        selected ? [newshield, ...shieldsNfts] : [...shieldsNfts, newshield]
      );
    } else {
      if (selected && selectedShields.length == MaxShields) {
        toast.error(` max weapons to this spaceship is ${MaxShields}`);
      }
    }
    let audio;
    if (selected && selectedShields.length <= MaxShields) {
      audio = new Audio('assets/audio/select2.mp3');
      audio.play();
      toast.success(` ${newshield.name} is selected`);
    } else {
      audio = new Audio('assets/audio/Unselect2.mp3');
      toast.error(` ${newshield.name} is unselected`);
    }
    audio.play();
    setRunChangeDiableState(!runChangeDiableState);
  };
  const repairekitsOnClick = (selected, id) => {
    let selectedRepairkits = repairekitNfts.filter(
      ({ isSelected }) => isSelected
    );
    let newRepair;
    //add only when user doesn't exceed max limit
    if ((selected && selectedRepairkits.length < 1) || !selected) {
      newRepair = repairekitNfts.find((r) => r.tokenId.toString() == id);
      const resIndex = repairekitNfts.findIndex(
        (r) => r.tokenId.toString() == id
      );
      repairekitNfts.splice(resIndex, 1);
      newRepair.isSelected = selected;
      setRepairekitNfts(
        selected
          ? [newRepair, ...repairekitNfts]
          : [...repairekitNfts, newRepair]
      );
    } else {
      if (selected && selectedRepairkits.length == 1) {
        toast.error(` max weapons to this spaceship is ${1}`);
      }
    }
    let audio;
    if (selected && selectedRepairkits.length <= 1) {
      audio = new Audio('assets/audio/select3.mp3');
      audio.play();
      toast.success(` ${newRepair.name} is selected`);
    } else {
      audio = new Audio('assets/audio/Unselect3.mp3');
      toast.error(` ${newRepair.name} is unselected`);
    }
    audio.play();
    setRunChangeDiableState(!runChangeDiableState);
  };
  const joinFightButton = () => {
    let selectedWeapons = weaponsNfts.filter(({ isSelected }) => isSelected);
    let selectedShields = shieldsNfts.filter(({ isSelected }) => isSelected);
    let selectedRepairKit = repairekitNfts.filter(
      ({ isSelected }) => isSelected
    );
    if (
      selectedWeapons.length > 0 &&
      selectedShields.length > 0 &&
      selectedRepairKit.length > 0
    ) {
      localStorage.setItem(
        'GameData',
        JSON.stringify({
          spaceship: spaceshipcheckedtemp,
          weapons: selectedWeapons,
          shields: selectedShields,
          repairekits: selectedRepairKit,
        })
      );
      setSelectSpaceshipWarMatrial(true);
    } else {
      toast.error('Check at least one [weapon , shield , repaire kit]');
    }
  };
  const checkPoftofolio = () => {
    if (spaceshipcheckedtemp != null) {
      spaceshipOnClick(spaceshipcheckedtemp);
      localStorage.removeItem('portofolioChosen');
    }
  };

  const disableJoin = () => {
    let flag;
    let selectedWeapons = weaponsNfts?.filter(({ isSelected }) => isSelected);
    let selectedShields = shieldsNfts?.filter(({ isSelected }) => isSelected);
    let selectedRepairKit = repairekitNfts?.filter(
      ({ isSelected }) => isSelected
    );
    if (
      selectedWeapons?.length == 0 ||
      selectedShields?.length == 0 ||
      selectedRepairKit?.length == 0
    ) {
      flag = true;
    } else {
      flag = false;
    }
    setDisabledAttr(flag);
  };

  function PhaserCanvas(props) {
    return (
      <>
        <div className="d-flex justify-content-center pt-5 pb-5 game-container game-area-background">
          {isConnected &&
          payingScreen &&
          selectSpaceship &&
          selectSpaceshipWarMatrial ? (
            <>
              <IonPhaser game={game} initialize={initialize} />
            </>
          ) : (
            <>
              {!isConnected ? (
                <PromptLogin />
              ) : (
                <>
                  {isConnected && chain.id != 84532 ? (
                    <>
                      <div className="section-title mb-50">
                        <h2>
                          Please Conect to <span>Base Sepolia Network</span>
                        </h2>
                      </div>
                    </>
                  ) : (
                    <>
                      {spaceShips ? (
                        spaceShips.length > 0 ? (
                          <>
                            {!selectSpaceship ? (
                              <div className="container">
                                <div className="row">
                                  <div className="col-lg-6 col-md-8">
                                    <div className="section-title mb-50">
                                      <h2>
                                        Choose Your <span>Spaceship</span>
                                      </h2>
                                      <h4>
                                        You have{' '}
                                        <span className="text-brand">
                                          {spaceShips.length} SpaceShip(s)
                                        </span>
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  {spaceShips.map((item, index) => (
                                    <div
                                      className="col-lg-4 col-md-6 col-sm-12"
                                      key={index}
                                    >
                                      <SingleUserOwnedNFT
                                        item={item}
                                        type={NFTSTypes.spaceship}
                                        action={() => {
                                          const spaceshipobj = {
                                            name: item.name,
                                            image: item.image,
                                            sprite_photo: item.sprite_photo,
                                            soundLeft: item.sounds[0],
                                            soundRight: item.sounds[1],
                                            soundDown: item.sounds[2],
                                            soundUp: item.sounds[3],
                                            fireCapacity:
                                              item.properties.fireCapacity,
                                            level: item.properties.level,
                                            maxFuel: item.properties.maxFuel,
                                            maxShields:
                                              item.properties.maxShields,
                                            maxWeapons:
                                              item.properties.maxWeapons,
                                            resilience:
                                              item.properties.resilience,
                                            speed: item.properties.speed,
                                          };
                                          spaceshipOnClick(spaceshipobj);
                                        }}
                                        isClickable={true}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              <>
                                {/* ///////////////////////////////////War Matrial///////////////////////////////////////// */}
                                {/* /////////////////////////////////////////////////// */}
                                {weaponsNfts &&
                                weaponsNfts?.length != 0 &&
                                shieldsNfts?.length != 0 &&
                                repairekitNfts &&
                                repairekitNfts?.length != 0 ? (
                                  <>
                                    <div className="container">
                                      <div className="row">
                                        <div className="col-lg-6 col-md-8">
                                          <div className="section-title mb-80">
                                            <h2>
                                              Configure Your{' '}
                                              <span>Spaceship</span>
                                            </h2>
                                            <div>
                                              This SpaceShip
                                              <img
                                                src="assets/img/icon/spaceship.png"
                                                width={30}
                                                className="mr-1"
                                              />
                                              has Max
                                              <span className="text-brand">
                                                <p className="mt-2">
                                                  <span className="text-brand">
                                                    <strong>
                                                      {MaxWeapons}
                                                    </strong>
                                                    <img
                                                      src="assets/img/icon/gun.png"
                                                      width={30}
                                                    />
                                                    Weapon(s)
                                                  </span>
                                                  <span className="text-brand mx-3">
                                                    <strong>
                                                      {MaxShields}
                                                    </strong>
                                                    <img
                                                      src="assets/img/icon/shield.png"
                                                      width={30}
                                                    />
                                                    Shield(s)
                                                  </span>
                                                  <span className="text-brand">
                                                    <strong>{1} </strong>
                                                    <img
                                                      src="assets/img/icon/repair.png"
                                                      width={30}
                                                    />
                                                    Repair Kit
                                                  </span>
                                                </p>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-4">
                                          {spaceshipcheckedtemp && (
                                            <>
                                              <SingleUserOwnedNFT
                                                item={spaceshipcheckedtemp}
                                                type={NFTSTypes.spaceship}
                                                contentClassName={'m-0'}
                                              />

                                              <div className="latest-games-items">
                                                <Button
                                                  variant="contained"
                                                  color="warning"
                                                  size="large"
                                                  id="button-width"
                                                  onClick={() => {
                                                    joinFightButton();
                                                  }}
                                                  className="join-btn"
                                                  disabled={disabledAttr}
                                                >
                                                  Join Fight
                                                </Button>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                        <div className="col-8 configure-tabs-container ">
                                          <Tabs
                                            id="configure-tabs"
                                            activeKey={tabsKey}
                                            onSelect={(k) => setTabsKey(k)}
                                            className="mb-3 configure-tabs"
                                          >
                                            <Tab
                                              eventKey={NFTSTypes.weapon}
                                              title={
                                                <>
                                                  <img
                                                    src={
                                                      'assets/img/icon/gun.png'
                                                    }
                                                  />{' '}
                                                  <span className="text-white">
                                                    {weaponsNfts.filter(
                                                      ({ isSelected }) =>
                                                        isSelected
                                                    ).length +
                                                      '/' +
                                                      MaxWeapons}
                                                  </span>
                                                </>
                                              }
                                            >
                                              <Row>
                                                <Col>
                                                  <h4>
                                                    You selected{' '}
                                                    {
                                                      weaponsNfts.filter(
                                                        ({ isSelected }) =>
                                                          isSelected
                                                      ).length
                                                    }{' '}
                                                    out of {MaxWeapons}
                                                  </h4>
                                                </Col>
                                              </Row>
                                              <div className="d-flex">
                                                {weaponsNfts.map(
                                                  (item, index) => (
                                                    <div
                                                      className="single-item-to-scroll m-2"
                                                      key={index}
                                                    >
                                                      <div
                                                        className={`single-item-to-scroll ${
                                                          item.isSelected &&
                                                          'selectedItem'
                                                        }`}
                                                      >
                                                        <SingleUserOwnedNFT
                                                          isConfigurator={true}
                                                          item={item}
                                                          type={
                                                            NFTSTypes.weapon
                                                          }
                                                          action={(
                                                            action,
                                                            id
                                                          ) => {
                                                            weaponsOnClick(
                                                              action,
                                                              id
                                                            );
                                                          }}
                                                          isClickable={true}
                                                        />
                                                        <div
                                                          className={`text-center pr-2 ${
                                                            item.isSelected &&
                                                            'text-brand'
                                                          }`}
                                                        >
                                                          {item.name}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </Tab>
                                            <Tab
                                              eventKey={NFTSTypes.shield}
                                              title={
                                                <>
                                                  {' '}
                                                  <img
                                                    src={
                                                      'assets/img/icon/shield.png'
                                                    }
                                                  />
                                                  <span className="text-white ml-1">
                                                    {shieldsNfts.filter(
                                                      ({ isSelected }) =>
                                                        isSelected
                                                    ).length +
                                                      '/' +
                                                      MaxShields}
                                                  </span>
                                                </>
                                              }
                                            >
                                              <Row>
                                                <Col>
                                                  <h4>
                                                    You selected{' '}
                                                    {
                                                      shieldsNfts.filter(
                                                        ({ isSelected }) =>
                                                          isSelected
                                                      ).length
                                                    }{' '}
                                                    out of {MaxShields}
                                                  </h4>
                                                </Col>
                                              </Row>
                                              <div className="d-flex">
                                                {shieldsNfts.map(
                                                  (item, index) => (
                                                    <div
                                                      className="single-item-to-scroll m-2"
                                                      key={index}
                                                    >
                                                      <div
                                                        className={`single-item-to-scroll ${
                                                          item.isSelected &&
                                                          'selectedItem'
                                                        }`}
                                                      >
                                                        <SingleUserOwnedNFT
                                                          isConfigurator={true}
                                                          item={item}
                                                          type={
                                                            NFTSTypes.shield
                                                          }
                                                          action={(
                                                            action,
                                                            id
                                                          ) => {
                                                            shieldsOnClick(
                                                              action,
                                                              id
                                                            );
                                                          }}
                                                          isClickable={true}
                                                        />
                                                        <div
                                                          className={`text-center pr-2 ${
                                                            item.isSelected &&
                                                            'text-brand'
                                                          }`}
                                                        >
                                                          {item.name}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </Tab>
                                            <Tab
                                              eventKey={NFTSTypes.repairKit}
                                              title={
                                                <>
                                                  {' '}
                                                  <img
                                                    src={
                                                      'assets/img/icon/repair.png'
                                                    }
                                                  />{' '}
                                                  <span className="text-white">
                                                    {repairekitNfts.filter(
                                                      ({ isSelected }) =>
                                                        isSelected
                                                    ).length + '/1'}
                                                  </span>
                                                </>
                                              }
                                            >
                                              <Row>
                                                <Col>
                                                  <h4>
                                                    You selected{' '}
                                                    {
                                                      repairekitNfts.filter(
                                                        ({ isSelected }) =>
                                                          isSelected
                                                      ).length
                                                    }{' '}
                                                    out of {1}
                                                  </h4>
                                                </Col>
                                              </Row>
                                              <div className="d-flex">
                                                {repairekitNfts.map(
                                                  (item, index) => (
                                                    <div
                                                      className="single-item-to-scroll m-2"
                                                      key={index}
                                                    >
                                                      <div
                                                        className={`single-item-to-scroll ${
                                                          item.isSelected &&
                                                          'selectedItem'
                                                        }`}
                                                      >
                                                        <SingleUserOwnedNFT
                                                          isConfigurator={true}
                                                          item={item}
                                                          type={
                                                            NFTSTypes.repairKit
                                                          }
                                                          action={(
                                                            action,
                                                            id
                                                          ) => {
                                                            repairekitsOnClick(
                                                              action,
                                                              id
                                                            );
                                                          }}
                                                          isClickable={true}
                                                        />
                                                        <div
                                                          className={`text-center pr-2 ${
                                                            item.isSelected &&
                                                            'text-brand'
                                                          }`}
                                                        >
                                                          {item.name}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </Tab>
                                          </Tabs>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    {(weaponsNfts &&
                                      weaponsNfts?.length == 0) ||
                                    (shieldsNfts && shieldsNfts?.length == 0) ||
                                    (repairekitNfts &&
                                      repairekitNfts?.length == 0) ? (
                                      <div className="container">
                                        <div className="section-title mb-50">
                                          <h2>
                                            You must have at least one{' '}
                                            <span>
                                              Weapon , Shield and Repair Kit
                                            </span>
                                            <h3>
                                              <span>
                                                Buy one from the{' '}
                                                <a href="/#/shop">store</a>
                                              </span>
                                            </h3>
                                          </h2>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="container">
                                        <div className="section-title mb-50">
                                          <h2>
                                            Loading Your{' '}
                                            <span>War Material</span>
                                          </h2>
                                        </div>
                                        <div className="row justify-content-center">
                                          <Loader />
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </>
                              /////////////////////////////////end War Matrial///////////////////
                            )}
                          </>
                        ) : (
                          <div className="container">
                            <div className="section-title mb-50">
                              <h2>
                                You don't have any <span>Spaceship</span>
                                <h3>
                                  <span>
                                    Buy one from the <a href="/#/shop">store</a>
                                  </span>
                                </h3>
                              </h2>
                            </div>
                          </div>
                        )
                      ) : (
                        <div className="container">
                          <div className="section-title mb-50">
                            <h2>
                              Loading Your <span>Spaceship</span>
                            </h2>
                          </div>
                          <div className="row justify-content-center">
                            <Loader />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </>
    );
  }
  //PhaserCanvas = React.memo(PhaserCanvas);

  return (
    <Fragment>
      <Header name="non-sticky-header" />
      {window.innerWidth < 500 ? (
        <div id="div-height">
          <h1> this game must be played on Pc </h1>
        </div>
      ) : (
        <PhaserCanvas />
      )}
      <Footer />
    </Fragment>
  );
};

export default GameConfigurator;
